import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KlyantService } from '../../shared/services/klyant.service';

@Component({
  selector: 'app-klyant-auth',
  templateUrl: './klyant-auth.component.html',
  styleUrls: ['./klyant-auth.component.scss']
})
export class KlyantAuthComponent implements OnInit {  

  
  isLoaded: boolean = false;
  isError: boolean = false;
  errorMessage: string = '';

  constructor(
    private router: Router, 
    activatedRoute: ActivatedRoute, 
    private klyantService: KlyantService) {

      activatedRoute.params.subscribe(params => {
        if(params['code']) {
          this.getTokenFromUrlCode(params['code']);
        }
        if(params['error']) {
          this.isError = true;
          this.errorMessage = params['error'];          
        }
      });

  }

  ngOnInit(): void {
  }

  closeWindow() {
    window.close();
  }

  // Invoked on a callback after logging into Klyant
  getTokenFromUrlCode(code:any) {
    if (code != null) {
      this.klyantService.setTokenAfterCallback(code).subscribe(() => {
        this.closeWindow();
      });      
    }
  }



 
}
